import constants from 'app/constants'

/**
 * Parse the brands
 *
 * @param {Array} elements - the elements
 * @returns {object} the parsed products
 */
export default function parseProducts (elements) {
  const res = elements
    .filter(
      item =>
        item.isAvailable &&
        constants.AVATAR_PRODUCT_CATEGORIES.includes(item.layer)
    )
    .sort((a, b) => b.id - a.id)

  return res
}
